/** Import modules */

import { useTranslation }   from "react-i18next";

import { useQuery }         from "@apollo/client";

import { Helmet }           from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../Components/SEO/localizedMeta";

import { FrontEndPages }    from "../../Queries/Policies";

import ComponentLoader from "../../Components/Layout/Loaders/Loader";

import cookies              from "js-cookie";

import parse               from "html-react-parser";

/** Import components */

import Breadcrumbs          from "../../Components/Layout/Header/Breadcrumbs";

import ContentsLayout       from "../../Components/Contents/Layout";

/**
 * 
 * @returns About us page
 * 
 */

const About = () => { const { t, i18n } = useTranslation (),

    currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    canonicalHref = localizedAbsoluteUrl("/content/about", currentLanguage),

    alternateLinks = hreflangLinks("/content/about"),

    pageDescription = localizedValue({
        lv: "Uzzini vairāk par Tireshop.lv - pieredzējis riepu centrs un autoserviss ar plašu riepu, disku un akumulatoru piedāvājumu, profesionālu pieeju un kvalitatīvu apkalpošanu.",
        en: "Learn more about Tireshop.lv - an experienced tire center and car service with a wide range of tires, rims, and batteries and professional customer care.",
        ru: "Узнайте больше о Tireshop.lv - опытный центр шин и автосервис с широким выбором шин, дисков и аккумуляторов и профессиональным обслуживанием."
    }, currentLanguage),

    { data, loading } = useQuery ( FrontEndPages, { variables: { pageType: "about", language: cookies.get ( 'i18next' ) } } );

    /** Render component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ t ( "about_us" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "about_us" ), URI: "/content/about" }

        ] } />

        <ContentsLayout title={ t ( "about_us" ) }>
            
            { 

                loading ? <ComponentLoader /> :

                    data?.frontendPages?.edges[0]?.node?.content ?
            
                        parse ( data.frontendPages.edges[0].node.content ) :

                        <p>Unable to retrive data.</p>
                
            }

        </ContentsLayout>

        
        
    </div> );

}

/** Export component */
 
export default About;
